'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "legacy-board-container" */'./LegacyBoardContainer').then(mod => mod.default)
});